<!-- Contains the template and references the TypeScript logic. -->
<template>
    <div id="hero-map" ref="mapContainer" class="w-full h-full rounded-lg"></div>

  <!-- <div id="hero-map" class="relative w-full h-full rounded-lg">
    <div class="absolute bottom-1 right-1 text-[10px] text-gray-400 bg-white/80 px-1.5 py-0.5 rounded-sm shadow-sm z-[1000]">
      © <a href="https://www.esri.com/en-us/home" target="_blank" rel="noopener" class="underline">Esri</a>
    </div>
  </div> -->

</template>

<script lang="ts">
import HeroMap from './HeroMap';
import 'leaflet-draw/dist/leaflet.draw.css';
import 'leaflet-draw'; // Extends L with draw methods

export default HeroMap;
</script>

<style lang="css">
/* Use a more specific selector */
#hero-map .leaflet-div-icon.leaflet-editing-icon {
    background-color: #fff !important;
    border: 2px solid #0071BC !important;
    width: 14px !important;
    height: 14px !important;
    margin-top: -7px !important;   /* -height/2 */
    margin-left: -7px !important;  /* -width/2 */
    box-shadow: 0 0 6px rgba(0,0,0,0.30);
}
</style>
